<div class="row mt-2">
  <div class="col-sm-12">
    <div class="inputWithIcon inputWithIcon-search float-right d-flex">
      <app-advanced-mode id="assessmentGridAdvancedSwitch" [storageKey]="getAdvancedGridStorageKey(archived)"
        (collapsibleToggle)="enableAdvanced=$event">
      </app-advanced-mode>
      <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-NAME' | translate }}"
        (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-NAME' | translate }}" />
      <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
    </div>
  </div>
</div>
<div class="mt-3 ml-3 mr-3">
  <kendo-grid #grid [data]="gridView" [pageable]="total > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
    [pageSize]="state.take" [skip]="state.skip" [loading]="loading" [sort]="state.sort" [filter]="state.filter"
    [sortable]="true" [filterable]="enableAdvanced" [columnMenu]="enableAdvanced" [resizable]="true" [navigable]="true"
    [reorderable]="enableAdvanced" [ngClass]="{'mb-3': archived}" (dataStateChange)="dataStateChange($event)">
    <kendo-grid-messages noRecords="{{ 'NO-ASSESSMENTS' | translate }}">
    </kendo-grid-messages>
    <kendo-grid-column class="ellipsis-text" field="name" title="{{ 'NAME' | translate }}" [width]="20">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span title="{{dataItem.name}}">{{dataItem.name}}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="type" title="{{ 'ASSESSMENT-TYPE' | translate }}" [width]="12">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem.type">{{dataItem.type.name}}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column class="ellipsis-text" field="description" title="{{ 'DESCRIPTION' | translate }}" [width]="20">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span title="{{dataItem.description}}">{{dataItem.description}}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="assessmentVersion" title="{{ 'VERSION' | translate }}" [width]="8">
    </kendo-grid-column>
    <kendo-grid-column class="text-center" field="privateAssessment" [width]="10" title="{{ 'PRIVATE' | translate }}"
      filter="boolean">
      <ng-template kendoGridCellTemplate let-dataItem>
        <i *ngIf="dataItem.privateAssessment" class="fas fa-check"></i>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="createdBy" [width]="10" title="{{ 'CREATED-BY' | translate }}">
    </kendo-grid-column>
    <kendo-grid-column field="createdOn" [width]="12" title="{{ 'CREATED-DATE' | translate }}" filter="date"
      format="{0:g}">
    </kendo-grid-column>
    <kendo-grid-column field="lastModifiedBy" [width]="10" title="{{ 'LAST-MODIFIED-BY' | translate }}">
    </kendo-grid-column>
    <kendo-grid-column field="lastModifiedOn" [width]="12" title="{{ 'LAST-MODIFIED-DATE' | translate }}" filter="date"
      format="{0:g}">
    </kendo-grid-column>
    <kendo-grid-column *ngIf="!archived" class="text-center" field="active" [width]="8"
      title="{{ 'ENABLED' | translate }}" filter="boolean">
      <ng-template kendoGridCellTemplate let-dataItem>
        <i *ngIf="dataItem.active" class="fas fa-check"></i>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-command-column [width]="14" title="{{ 'ACTIONS' | translate }}" class="text-center">
      <ng-template kendoGridCellTemplate let-dataItem>
        <i [ngClass]="{'fa-edit': !archived, 'fa-eye': archived}" class="fas fa-edit fa-lg"
          title="{{ (archived ? 'VIEW' : 'EDIT') | translate }}" (click)="editHandler(dataItem['id'])">
        </i>
        <span *ngIf="!archived">
          &nbsp;
          <i class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}" (click)="deleteHandler(dataItem['id'])">
          </i>
        </span>
        &nbsp;
        <i class="fas fa-file-export pointer fa-lg" style="color:#bc7410"
          title="{{ 'EXPORT-ASSESSMENT-SETUP' | translate }}" [ngClass]="{'extra-padding': dataItem.source !== 'FORM'}"
          (click)="saveFileLocal(dataItem.id, dataItem.name)">
        </i>
        &nbsp;
        <i class="fas fa-file-csv fa-lg" *ngIf="dataItem.source === 'FORM'"
          title="{{ 'EXPORT-ASSESSMENTS' | translate }}"
          (click)="exportCompletedAssessments(dataItem['id'], dataItem['assessmentVersion'], dataItem['name'])">
        </i>
      </ng-template>
    </kendo-grid-command-column>
  </kendo-grid>
  <button appPreventClick *ngIf="!archived" kendoButton [primary]="false" type="button" class="float-right mt-3 mb-3"
    (click)="addHandler()">
    {{'ADD' | translate}}<i class="far fa-plus"></i>
  </button>
</div>

<!--Delete confirmation dialog-->
<kendo-dialog *ngIf="deleteDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
  (close)="deleteDialogOpened = false">
  <p>{{'CONFIRM-ASSESSMENT-DELETION' | translate}}</p>
  <span class="k-font-weight-bold">{{selectedAssessment.name}}</span>
  <kendo-dialog-actions>
    <button kendoButton (click)="deleteDialogOpened = false">{{'NO' | translate}}</button>
    <button appPreventClick kendoButton (click)="deleteAssessment()">{{'YES' | translate}}</button>
  </kendo-dialog-actions>
</kendo-dialog>

<!--Add/Edit form-->
<app-assessment-edit [formModel]="editDataItem" [isNew]="isNew" (save)="saveChangesHandler($event)"
  (cancelling)="cancelChangesHandler()">
</app-assessment-edit>

<app-assessment-export #exportAssessment></app-assessment-export>